"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RENTAL_DAILY_PRICE_TYPE = void 0;
var RENTAL_DAILY_PRICE_TYPE;
(function (RENTAL_DAILY_PRICE_TYPE) {
    RENTAL_DAILY_PRICE_TYPE["FIELD_NAME"] = "rental_price_type";
    RENTAL_DAILY_PRICE_TYPE["RENTAL_PRIZE_TYPE"] = "daily_price";
    RENTAL_DAILY_PRICE_TYPE["MONTHLY_PRICE"] = "monthly_price";
})(RENTAL_DAILY_PRICE_TYPE = exports.RENTAL_DAILY_PRICE_TYPE || (exports.RENTAL_DAILY_PRICE_TYPE = {}));
